import { render, staticRenderFns } from "./RhComprasAnaliticoRead.vue?vue&type=template&id=72bd0b86&"
import script from "./RhComprasAnaliticoRead.vue?vue&type=script&lang=js&"
export * from "./RhComprasAnaliticoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports